import Facebook from './FAcebook.svg';
import YouTube from './Youtube.svg';
import Telegram from './Telegram.svg';
import Linkedin from './LinkedIn.svg';
import Twitter from './Twitter.svg';
import Whatsapp from './Whatsapp.svg';
import Logo from './Logo.png';
import Account from './Account.svg';
import Heart from './Heart.svg';
import Cart from './Cart.svg';
import SearchIcon from './SearchIcon.svg';
import CartHero from './CartHero1.svg';
import Return from './Return.png';
import Truck from './Truck.png';
import CartHeroTwo from './CartHero2.png';
import categoryIcons from './categoryIcons';
import NewsLetterBg from './NewsLetterBg.png';
import CartCard from './CartCard.svg';
import FullStar from './StarFull.svg';
import HalfStar from './StarHalf.svg';
import Grid from './Grid.svg';
import Hamburger from './Hamburger.svg';
import GrayStar from './grayStar.svg';
import GoldStar from './goldStar.svg';
import CloseCircleOutlined from './close-circle-outlined.svg';
import CloseCircleForItmes from './close-for-cart-itmes.svg';
import ProductAddedTick from './productAddedTick.svg';


export const catIcons = categoryIcons;

export {
  SearchIcon,
  CartHero,
  Return,
  Truck,
  CartHeroTwo,
  NewsLetterBg,
  CartCard,
  FullStar,
  HalfStar,
  Grid,
  Hamburger,
  GrayStar,
  GoldStar,
  CloseCircleOutlined,
  CloseCircleForItmes,
  ProductAddedTick
};

const icons = {
  YouTube,
  Facebook,
  Twitter,
  Whatsapp,
  Linkedin,
  Telegram,
  Logo,
  Account,
  Heart,
  Cart,
};

export default icons;
